import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminTaxaNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('taxon');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
